import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { DispatchFunction, IAgentDetail, IAgentType, IActiveFilter } from '@app/models';
import { GET_ALL_AGENTS, GET_AGENT_TYPES, GET_AGENT_TYPES_LOADING, SET_AGENT_COUNT, GET_AGENT_DETAIL } from '@app/store/constants';
import { agentsService } from '@app/services';
import { loadingData } from './basic.actions';

export function handleGetAgentsData(
    orderBy: string,
    asc: string,
    top: number,
    skip: number,
    organizationId: string,
    isReset: boolean,
    filters?: IActiveFilter[]
): DispatchFunction {
    return ((dispatch: Dispatch) => {
        if (isReset) {
            dispatch(loadingData(true));
            dispatch(setAgentCount(0));
            dispatch(getAllAgents([]));
        }

        agentsService.getAgents(orderBy, asc, top, skip, organizationId, isReset, filters)
            .then((response: AxiosResponse) => {
                dispatch(getAllAgents(response.data.value));

                if (isReset) {
                    dispatch(setAgentCount(response.data['@odata.count']));
                    dispatch(loadingData(false));
                }
            })
            .catch((error) => {
                dispatch(loadingData(false));
            });
    });
}

export function handleGetAgentTypesData(): DispatchFunction {
    return ((dispatch: Dispatch) => {
        dispatch(getAgentTypesLoading(true));
        agentsService.getAgentTypes()
            .then((response: AxiosResponse) => {
                dispatch(getAgentTypes(response.data.value));
                dispatch(getAgentTypesLoading(false));
            });
    });
}


export function handleGetAgentData(agentId: string, handleError: Function, handleSuccess: Function): DispatchFunction {
    return ((dispatch: Dispatch) => {
        dispatch(loadingData(true));
        agentsService.getAgentProfiles(agentId, handleError, handleSuccess)
            .then((response: AxiosResponse) => {
                dispatch(getAgentDetail(response.data));
            })
            .then(() => dispatch(loadingData(false)));
    });
}

export function getAllAgents(agents: IAgentDetail[]) {
    return {
        payload: agents,
        type: GET_ALL_AGENTS
    };
};

export function getAgentTypes(agentTypes: IAgentType[]) {
    return {
        payload: agentTypes,
        type: GET_AGENT_TYPES
    };
};

function getAgentTypesLoading(agentTypesLoading: boolean) {
    return {
        payload: agentTypesLoading,
        type: GET_AGENT_TYPES_LOADING
    };
};

export function setAgentCount(count: number) {
    return {
        payload: count,
        type: SET_AGENT_COUNT
    };
};

export function getAgentDetail(agentData: IAgentDetail) {
    return {
        payload: agentData,
        type: GET_AGENT_DETAIL
    };
}
